import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { mergeMap, catchError, map, exhaustMap } from "rxjs/operators";
import { getRequestHeader } from "../../_helpers/request.header";
import { trafficFineConstants, responseCodes } from "../_constants";

import {
  ajaxError,
  finesListComplete,
  finesListError,
  payloadEncryptionFail,
  payloadEncryptionSuccess,
  policeStationsListComplete,
  policeStationsListError,
  trafficFineOTPConfirmComplete,
  trafficFineOTPConfirmError,
  trafficFineOTPResendComplete,
  trafficFineOTPResendError,
  trafficFinePayableListComplete,
  trafficFinePayableListError,
  trafficFinePayBillComplete,
  trafficFinePayBillError,
  trafficFineValidateAmountComplete,
  trafficFineValidateAmountError,
} from "../_actions";
import { payloadFormatter } from "../../_helpers/encryption.helper";

export const policeStationListEpic = (actions$) =>
  actions$.pipe(
    ofType(trafficFineConstants.POLICE_STATION_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/trafficFines/policeStationList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            policeStationsListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(policeStationsListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const finesListEpic = (actions$) =>
  actions$.pipe(
    ofType(trafficFineConstants.FINES_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/trafficFines/finesList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => finesListComplete(ajaxResponse.response)),
          catchError((error) => of(finesListError(error), ajaxError(error))),
        );
    }),
  );

export const trafficFinePayableListEpic = (actions$) =>
  actions$.pipe(
    ofType(trafficFineConstants.TRAFFIC_FINE_PAYABLE_LIST_REQUEST),
    mergeMap((action) => {
      const { setShowPayableListEmptyModal, ...finalPayload } = action.payload;
      return ajax
        .post(
          "/api/trafficFines/getPayableList",
          finalPayload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => {
            if (ajaxResponse.response.data.accountList.length === 0) {
              setShowPayableListEmptyModal?.(true);
            }

            return trafficFinePayableListComplete(ajaxResponse.response);
          }),
          catchError((error) =>
            of(trafficFinePayableListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const trafficFineValidateAmountEpic = (actions$) =>
  actions$.pipe(
    ofType(trafficFineConstants.TRAFFIC_FINE_VALIDATE_AMOUNT_REQUEST),
    mergeMap((action) => {
      const finalPayload = { ...action.payload };
      delete finalPayload.restoreData;
      return ajax
        .post(
          "/api/trafficFines/validateAmount",
          finalPayload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            trafficFineValidateAmountComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(trafficFineValidateAmountError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const trafficFinePayBillEpic = (actions$) =>
  actions$.pipe(
    ofType(trafficFineConstants.TRAFFIC_FINE_PAYBILL_REQUEST),
    exhaustMap((action) =>
      from(
        (async () => {
          try {
            const payload = await payloadFormatter(
              action.payload,
              "/api/trafficFines/payBill",
            );
            return payloadEncryptionSuccess(payload, action.payload);
          } catch (error) {
            return payloadEncryptionFail(error);
          }
        })(),
      ).pipe(
        mergeMap((encryptedAction) => {
          if (!encryptedAction?.encryptedPayload) {
            return of(encryptedAction);
          }
          return ajax
            .post(
              "/api/trafficFines/payBill",
              encryptedAction.encryptedPayload,
              getRequestHeader("POST"),
            )
            .pipe(
              map((ajaxResponse) =>
                trafficFinePayBillComplete(ajaxResponse.response),
              ),
              catchError((error) =>
                of(trafficFinePayBillError(error), ajaxError(error)),
              ),
            );
        }),
      ),
    ),
  );

export const trafficFineOtpConfirmEpic = (actions$) =>
  actions$.pipe(
    ofType(trafficFineConstants.TRAFFIC_FINE_OTP_CONFIRM_REQUEST),
    exhaustMap((action) => {
      const { setShowOtpModal, ...finalPayload } = action.payload;
      return ajax
        .post(
          "/api/trafficFines/otpConfirm",
          finalPayload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => {
            setShowOtpModal?.(false);
            return trafficFineOTPConfirmComplete(ajaxResponse.response);
          }),
          catchError((error) => {
            if (
              error.response?.errorResponse?.responseCode ==
                responseCodes.OTP_FAILED ||
              error.response?.errorResponse?.responseCode ==
                responseCodes.OTP_EXPIRED ||
              error.response?.errorResponse?.responseCode ==
                responseCodes.OTP_BLOCKED ||
              error.response?.errorResponse?.responseCode ==
                responseCodes.OTP_REQUEST_LIMIT_REACHED
            ) {
              setShowOtpModal?.(true);
            } else {
              setShowOtpModal?.(false);
            }
            return of(trafficFineOTPConfirmError(error), ajaxError(error));
          }),
        );
    }),
  );

export const trafficFineOtpResendEpic = (actions$) =>
  actions$.pipe(
    ofType(trafficFineConstants.TRAFFIC_FINE_OTP_RESEND_REQUEST),
    exhaustMap((action) => {
      const finalPayload = { ...action.payload };
      return ajax
        .post(
          "/api/trafficFines/otpResend",
          finalPayload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => {
            return trafficFineOTPResendComplete(ajaxResponse.response);
          }),
          catchError((error) => {
            return of(trafficFineOTPResendError(error), ajaxError(error));
          }),
        );
    }),
  );
